import { CounterCustomerChargeEntity } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeEntity";
import { ImportReHandlingCriteria } from "domain/entity/CounterCustomerCharge/ImportReHandlingCriteria";
import { getDefaultBuConfig } from "domain/repository/apiUtil";
import _ from "lodash";
import { AclType } from "presentation/constant/ANAInfo/NbisivPermission";
import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { CounterCustomerChargeMaintenanceConstant } from "presentation/constant/CounterCustomerCharge/CounterCustomerChargeMaintenanceConstant";
import { MessageConstant } from "presentation/constant/MessageConstant";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { isPermissionExist } from "presentation/utils/permissionUtils";
import { convertDateToDateTimeForComponent } from "presentation/utils/timeUtil";
import { CommonMessageModal } from "presentation/view/components/CommonMessageModal";
import { ConfirmDeleteModal } from "presentation/view/components/ConfirmDeleteModal";
import { HeaderWithBackButton } from "presentation/view/components/HeaderWithBackButton/HeaderWithBackButton";
import { OverflowMenuButton } from "presentation/view/components/OverflowMenuButton";
import { memo, useCallback, useMemo, useState, } from "react";
import { HPHBreadcrumb, HPHButton, IconButton } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const CounterCustomerChargeDetailPanelTitleBar: React.FC = () => {
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const { currentSelectedRow, selectedRows, isEnabledEditWaiver, isEnabledSuppleWaiver, isEnabledWaiver, isEnabledChargeCom, isEnabledBillCom, isEnableExciseCashNo, isEnablePaidThroughDate, isEnableChargeQty, isEnableExtraLabor, isEnableAccTerminal, isEnableHoldUnhold, tableData, isEnableAgentDeliveryDate, isEnableExtensionPayment, isEnableMarkMT, isEnableDelete, isEnableAdjustment, isEnableCfsStuffing, isEnableImporiReHandling, isEnablePreview } = counterCustomerChargeState;
    const messageBarVM = useMessageBarVM();
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit, allowUpdate, allowCreate } = anaInfoState;
    const maxNumber: number = getDefaultBuConfig<number>("REACT_APP_COUNTER_CHARGE_PREVIEW_MAX_COUNT") || 10;
    const [isShowCollectionMsg, setIsCollectionMsg] = useState<boolean>(false);
    const [isShowDeleteMsg, setIsDeleteMsg] = useState<boolean>(false);
    const [bkDraftDocNo, setBkDraftDocNo] = useState<string[]>([]);
    const allowUpdateMarkMT = isPermissionExist(Permission.COUNTER_CUSTOMER_CHARGE_MAINTENANCE_MARKMT, AclType.UPDATE, anaInfoState.defaultOperatingCompany, anaInfoState.allNbisivPermission);
    const allowUpdateDelete = isPermissionExist(Permission.COUNTER_CUSTOMER_CHARGE_MAINTENANCE_DELETE, AclType.UPDATE, anaInfoState.defaultOperatingCompany, anaInfoState.allNbisivPermission);
    const allowUpdateAdjustment = isPermissionExist(Permission.COUNTER_CUSTOMER_CHARGE_MAINTENANCE_ADJUSTMENT, AclType.UPDATE, anaInfoState.defaultOperatingCompany, anaInfoState.allNbisivPermission);

    const handleAdd = useCallback(async () => {
        let key: string;
        let isShowAdditional = true;
        if (selectedRows && selectedRows.length > 0) {
            key = selectedRows[0].billOfLading + '/' + selectedRows[0].soNumber + '/' + selectedRows[0].newOwner
                + '/' + selectedRows[0].opsDate + '/' + selectedRows[0].serviceCode + '/' + selectedRows[0].consortiumCode
                + '/' + selectedRows[0].vesselCode + '/' + selectedRows[0].voyageCode + '/' + selectedRows[0].etd
                + '/' + selectedRows[0].chargeOnCompany + '/' + selectedRows[0].billToCompany + '/' + selectedRows[0].agentNo
                + '/' + selectedRows[0].counterCustCompCode;
        }
        selectedRows?.forEach(async (row) => {
            if (selectedRows && selectedRows.length > 0) {
                let keys = row.billOfLading + '/' + row.soNumber + '/' + row.newOwner
                    + '/' + row.opsDate + '/' + row.serviceCode + '/' + row.consortiumCode
                    + '/' + row.vesselCode + '/' + row.voyageCode + '/' + row.etd
                    + '/' + row.chargeOnCompany + '/' + row.billToCompany + '/' + row.agentNo
                    + '/' + row.counterCustCompCode;
                if (key !== keys) {
                    messageBarVM.showError("Multiple header is found for your selection. Please choose either one.");
                    isShowAdditional = false;
                    return;
                }
            }
            if (row.dtlState !== 'R' && row.dtlState !== 'E' && row.dtlState !== 'F') {
                messageBarVM.showError("Please select chargeable records only.");
                isShowAdditional = false;
                return;
            }
        });
        if (isShowAdditional) {
            counterCustomerChargeVM.onAdd(currentSelectedRow);
        }
    }, [counterCustomerChargeVM, selectedRows, messageBarVM, currentSelectedRow]);

    /*const handleEdit = useCallback(() => {
        counterCustomerChargeVM.onEdit(currentSelectedRow);
    }, [currentSelectedRow, counterCustomerChargeVM])*/

    const handleApplyAll = useCallback(() => {
        counterCustomerChargeVM.onShowLoading();
        const ids = counterCustomerChargeState.tableData.map(x => x.id);
        counterCustomerChargeVM.onApplyAll(ids).then(async (data) => {
            if (data && data.success) {
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                counterCustomerChargeVM.onHideLoading();
                if (data.msg && data.msg !== 'OK') {
                    messageBarVM.showError(data.msg);
                } else {
                    messageBarVM.showSuccess("Apply Successfully.");
                }
            } else {
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                counterCustomerChargeVM.onHideLoading();
                messageBarVM.showError("Apply Failed.");
            }
        });

    }, [counterCustomerChargeVM, counterCustomerChargeState.tableData, counterCustomerChargeState.searchCriteria, messageBarVM])

    const handleConfirm = useCallback(async () => {
        let searchCriteria = counterCustomerChargeState.searchCriteria;
        const table = selectedRows && selectedRows.length > 0 ? selectedRows : tableData;
        let soNumberList: string[] = [];
        if (operatingUnit !== 'SAPT' && operatingUnit !== 'KICT') {
            let msg: string | null = null;
            let isAllSAOrDI = true;
            table.forEach(item => {
                if ((item.chargeType === 'CC' && item.subChargeType === 'ITM')
                    || (item.chargeType === 'ITM' && item.adjType !== 'Cancel Only')
                    || (item.chargeType === 'DEM' && item.subChargeType === 'DEI')
                    || (item.chargeType === 'RFH' && item.subChargeType === 'PCI' && item.plugOffInd === 'N' && item.adjType !== 'Cancel Only')
                    || (item.chargeType === 'RFH' && item.subChargeType === 'FDC')
                    || (item.chargeType === 'RFH' && item.subChargeType === 'MONITORI' && item.plugOffInd === 'N' && item.adjType !== 'Cancel Only')
                    || (item.chargeType === 'CSR' && item.subChargeType === 'ST')) {
                    if (!item.paidThroughDate && (item.dtlState === 'R' || item.dtlState === 'F')) {
                        msg = 'Paid through date is mandatory.';
                    }
                }
                if (item.dtlState === 'R' || item.dtlState === 'C' || item.dtlState === 'F' || item.dtlState === 'T' || item.dtlState === 'I' ||
                    item.dtlState === 'E' || item.dtlState === 'H' || item.dtlState === 'SH' || item.dtlState === 'MH' || item.dtlState === 'MT' ||
                    item.dtlState === 'Z' || item.dtlState === 'X' || item.dtlState === 'SG') {
                    isAllSAOrDI = false;
                }

                if (item.shippingBill && !soNumberList.includes(item.shippingBill)) {
                    soNumberList.push(item.shippingBill);
                }
            })

            if (operatingUnit === 'RSCT' || operatingUnit === 'AQCT') {
                await counterCustomerChargeVM.isCheckPaidThroughDateForIB(table.filter(item => item.dtlState === 'R' || item.dtlState === 'F')).then((ret) => {
                    if (ret.success) {
                        msg = 'Please input the paid through date for import container.';
                        messageBarVM.showError(msg);
                        return;
                    }
                }).catch((error) => {
                    messageBarVM.showError('search charge Failed!');
                });

                const currentDate = new Date();//dd-MM-yyyy HH:mm:ss
                table.forEach(item => {
                    if ((item.dtlState === 'R' || item.dtlState === 'F' || item.dtlState === 'E') && (item.paidThroughDate && new Date(item.paidThroughDate) < new Date(currentDate))) {
                        if ((!(item.chargeType === 'RFH' && (item.subChargeType === 'PCI' || item.subChargeType === 'MONITORI') && item.plugOffInd === 'Y'))
                            && (!((item.adjType === 'Cancel Only') &&
                                (item.chargeType === 'ITM' || (item.chargeType === 'RFH' && (item.subChargeType === 'PCI' || item.subChargeType === 'MONITORI')))))
                        ) {
                            if (item.adjType === 'Normal') {
                                msg = "Paid Through Date " + convertDateToDateTimeForComponent(item.paidThroughDate) + " is not allow back date.";
                            }
                        }
                    }
                })
            }

            if (isAllSAOrDI) {
                msg = 'Record status are only SA & DI, cannot edit.';

            }
            if (msg !== null) {
                messageBarVM.showError(msg);
                return;
            }
        }

        if (operatingUnit === 'AQCT' || operatingUnit === 'RSCT') {
            let errorMsg = "";
            if (soNumberList && soNumberList.length > 0) {
                let chargeDtlIds: number[] = [];
                chargeDtlIds = table.map(item => item.id);
                await counterCustomerChargeVM.checkBookingChargeCntr(chargeDtlIds).then(async (data) => {
                    if (data && !data.success) {
                        errorMsg = "Booking or Booking container number is updated/removed in ngen!";
                        counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                        messageBarVM.showError(errorMsg);
                    }
                });
            }
            if (errorMsg) {
                return;
            }
        }

        if (operatingUnit !== 'SAPT' && operatingUnit !== 'KICT' && selectedRows && selectedRows.length > 0) {
            searchCriteria = {
                ...searchCriteria,
                chargeId: selectedRows.map(item => item.id)
            }
        }
        counterCustomerChargeVM.onShowLoading();
        counterCustomerChargeVM.onConfirmAndSubmit(searchCriteria, operatingUnit).then(async (data) => {
            counterCustomerChargeVM.onHideLoading();
            if (data && data.success) {
                counterCustomerChargeVM.onHideLoading();
                if (data.data) {
                    if (data.data.includes('Error:')) {
                        messageBarVM.showError(data.data.replace('Error:', ''));
                    } else {
                        await counterCustomerChargeVM.isShowPaymentOptional(table.filter(item => item.dtlState === 'R' || item.dtlState === 'F'), operatingUnit);
                        await counterCustomerChargeVM.getOldPaymentMode(table, operatingUnit);
                        await counterCustomerChargeVM.onSearchPaymentMode(data.data);
                        return;
                    }
                } else {
                    messageBarVM.showSuccess("Confirm Successfully.");
                }
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
            } else {
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                counterCustomerChargeVM.onHideLoading();
                messageBarVM.showError("Generate invoice fail.");
            }
        });
    }, [counterCustomerChargeVM, counterCustomerChargeState.searchCriteria, messageBarVM, operatingUnit, selectedRows, tableData])

    const handleCollection = useCallback(() => {
        setIsCollectionMsg(false);

        let draftDocNos: string[] = [];
        tableData.forEach(item => {
            if (item.dtlState === 'DI' && item.defaultDraftInvoiceNo && !draftDocNos.includes(item.defaultDraftInvoiceNo)) {
                draftDocNos.push(item.defaultDraftInvoiceNo);
            }
            if ((operatingUnit === 'OICT' || operatingUnit === 'HPJZ') && item.dtlState === 'I'
                && item.adjType === 'Cancel & Re-bill' && !item.defaultInvoiceNo && !item.defaultInvoiceNo
                && item.defaultDraftInvoiceNo && !draftDocNos.includes(item.defaultDraftInvoiceNo)) {
                draftDocNos.push(item.defaultDraftInvoiceNo);
            }
        });

        counterCustomerChargeVM.onShowLoading();
        counterCustomerChargeVM.onCollection(draftDocNos).then(async (data) => {
            if (data && data.success) {
                counterCustomerChargeVM.onHideLoading();
                await counterCustomerChargeVM.prevOrDownloadRpt(data.data, false);
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                messageBarVM.showSuccess("Collection Successfully.");
            } else {
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                counterCustomerChargeVM.onHideLoading();
                if (data.data) {
                    messageBarVM.showError(data.data);
                    if ((operatingUnit === 'AQCT' || operatingUnit === 'RSCT') && data.data.includes('please contact system support for assistance')) {
                        await counterCustomerChargeVM.onPrintForAQCT(draftDocNos);
                    }
                } else {
                    messageBarVM.showError("Collection Failed.");
                }
            }
        });
    }, [counterCustomerChargeVM, operatingUnit, tableData, messageBarVM, counterCustomerChargeState.searchCriteria]);

    const handleCollectionAndCheck = useCallback(async () => {
        let draftDocNos: string[] = [];
        let bkdraftDocNos: string[] = [];
        tableData.forEach(item => {
            if (item.dtlState === 'DI' && item.defaultDraftInvoiceNo && !draftDocNos.includes(item.defaultDraftInvoiceNo)) {
                draftDocNos.push(item.defaultDraftInvoiceNo);
                if ((operatingUnit === 'AQCT' || operatingUnit === 'RSCT') && item.shippingBill) {
                    bkdraftDocNos.push(item.defaultDraftInvoiceNo);
                }
            }
            if ((operatingUnit === 'OICT' || operatingUnit === 'HPJZ') && item.dtlState === 'I'
                && item.adjType === 'Cancel & Re-bill' && !item.defaultInvoiceNo && !item.defaultInvoiceNo
                && item.defaultDraftInvoiceNo && !draftDocNos.includes(item.defaultDraftInvoiceNo)) {
                draftDocNos.push(item.defaultDraftInvoiceNo);
            }
        });
        if (!draftDocNos || draftDocNos.length < 1) {
            messageBarVM.showError('No record to collection.');
            return;
        }
        if (draftDocNos && draftDocNos.length > 8) {
            messageBarVM.showError('Max. 8 records are allowed to collection!');
            return;
        }

        if (operatingUnit === 'AQCT' || operatingUnit === 'RSCT') {
            if (bkdraftDocNos && bkdraftDocNos.length > 0) {
                setBkDraftDocNo(bkdraftDocNos);
            }
            let isPropmtMessage = "";
            let isContinueCollection = false;
            await counterCustomerChargeVM.onCheckBookingCntrNo(draftDocNos).then(async (data) => {
                if (data && !data.success) {
                    if (data.data && typeof (data.data) === 'string') {
                        if (data.data === "ERROR: Search Ngen View fail!") {
                            isContinueCollection = true;
                            setIsCollectionMsg(true);
                            return;
                        } else {
                            isPropmtMessage = "Booking or Booking container number is updated/removed in ngen!";
                        }
                    }
                }
            });

            if (isPropmtMessage) {
                counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                messageBarVM.showError(isPropmtMessage);
                return;
            }

            if (!isContinueCollection) {
                handleCollection();
            }
        } else {
            handleCollection();
        }

    }, [tableData, operatingUnit, messageBarVM, counterCustomerChargeVM, counterCustomerChargeState.searchCriteria, handleCollection]);

    const handleCancelDelete = useCallback(async () => {
        setIsDeleteMsg(false);
    }, []);

    const handleShowDelete = useCallback(async () => {
        setIsDeleteMsg(true);
    }, []);

    const handleCancel = useCallback(async () => {
        setIsCollectionMsg(false);
        counterCustomerChargeVM.onShowLoading();
        let docHdrIds = await counterCustomerChargeVM.getDocHdrIds(bkDraftDocNo);
        await counterCustomerChargeVM.onRejectForBK(docHdrIds).then(async (data) => {
            if (data && data.success) {
                counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                counterCustomerChargeVM.onHideLoading();
            } else {
                counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                counterCustomerChargeVM.onHideLoading();
                messageBarVM.showError('Reject Booking document fail.');
            }
        })

    }, [bkDraftDocNo, counterCustomerChargeState.searchCriteria, counterCustomerChargeVM, messageBarVM]);

    const handleMarkMt = useCallback(async () => {
        counterCustomerChargeVM.onShowLoading();
        if (_.isEmpty(selectedRows)) {
            counterCustomerChargeVM.onHideLoading();
            messageBarVM.showError('Please select record(s).');
            return;
        }
        let isError = false;
        selectedRows.forEach(async (row) => {
            if (row.dtlState !== 'R' && row.dtlState !== 'E' && row.dtlState !== 'F' && row.dtlState !== 'MT') {
                counterCustomerChargeVM.onHideLoading();
                messageBarVM.showError('Record status is ' + row.dtlState + ', cannot MT.');
                isError = true;
                return;
            }
        });
        if (isError) {
            return;
        }
        const ids = selectedRows.map(x => x.id);
        counterCustomerChargeVM.onMarkMT(ids).then(async (data) => {
            if (data && data.success) {
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                counterCustomerChargeVM.onHideLoading();
                messageBarVM.showSuccess("Mark MT Successfully.");
            } else {
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                counterCustomerChargeVM.onHideLoading();
                messageBarVM.showError("Mark MT Failed.");
            }
        });
    }, [messageBarVM, selectedRows, counterCustomerChargeVM, counterCustomerChargeState.searchCriteria]);

    const handleUpdateInvoiceInfo = useCallback(async () => {
        if (_.isEmpty(selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }
        counterCustomerChargeVM.onMore("InvoiceInfo", selectedRows);
    }, [counterCustomerChargeVM, messageBarVM, selectedRows]);
    const handleUpdatePaidThroughDate = useCallback(async () => {
        if (_.isEmpty(selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }
        counterCustomerChargeVM.onMore("PaidThroughDate", selectedRows);
    }, [counterCustomerChargeVM, messageBarVM, selectedRows]);

    const handleUpdateAgentDeliveryDate = useCallback(async () => {
        if (_.isEmpty(selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }
        counterCustomerChargeVM.onMore("AgentDeliveryDate", selectedRows);
    }, [counterCustomerChargeVM, messageBarVM, selectedRows]);

    const handleExtensionPayment = useCallback(async () => {
        if (_.isEmpty(selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }
        counterCustomerChargeVM.onMore("ExtensionPayment", selectedRows);
    }, [counterCustomerChargeVM, messageBarVM, selectedRows]);

    const handlePreview = useCallback(async () => {
        if (_.isEmpty(selectedRows)) {
            counterCustomerChargeVM.onHideLoading();
            messageBarVM.showError('Please select record(s).');
            return;
        }
        counterCustomerChargeVM.onShowLoading();

        let draftDocNoList: string[] = [];
        let invoiceCounter: number = 0;
        selectedRows.forEach((row) => {
            if (row.defaultDraftInvoiceNo && !draftDocNoList.includes(row.defaultDraftInvoiceNo)) {
                draftDocNoList.push(row.defaultDraftInvoiceNo);
                invoiceCounter++;
            }
            if (row.defaultDraftCreditNo && !draftDocNoList.includes(row.defaultDraftCreditNo)) {
                draftDocNoList.push(row.defaultDraftCreditNo);
            }
        });

        if (invoiceCounter > maxNumber) {
            counterCustomerChargeVM.onHideLoading();
            messageBarVM.showError('Preview invoice not allowed more than ' + maxNumber + ' records.');
            return;
        }
        if (!draftDocNoList.length) {
            counterCustomerChargeVM.onHideLoading();
            messageBarVM.showError("No record to preview.");
            return;
        }
        await counterCustomerChargeVM.previewDocReport(draftDocNoList);
        counterCustomerChargeVM.onHideLoading();
    }, [counterCustomerChargeVM, selectedRows, messageBarVM, maxNumber]);
    const handleUpdateChargeOnCompany = useCallback(async () => {
        counterCustomerChargeVM.onMore("ChargeOnCompany", []);
    }, [counterCustomerChargeVM]);
    const handleUpdateBillToCompany = useCallback(async () => {
        counterCustomerChargeVM.onMore("BillToCompany", []);
    }, [counterCustomerChargeVM]);
    const handleWaiverReasonCode = useCallback(async () => {
        counterCustomerChargeVM.onMore("WaiverReasonCode", [])
    }, [counterCustomerChargeVM]);
    const handleEditWaiver = useCallback(async () => {
        counterCustomerChargeVM.onShowLoading();
        const ids = counterCustomerChargeState.selectedRows.map(x => x.id);
        counterCustomerChargeVM.onEditWaiver(ids).then(async (data) => {
            if (data && data.success) {
                if (data.data) {
                    messageBarVM.showError(data.data);
                } else {
                    messageBarVM.showSuccess("Edit Waiver Successfully.");
                    counterCustomerChargeVM.onAddEditWaiver(ids);
                }
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                counterCustomerChargeVM.onHideLoading();
            } else {
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                counterCustomerChargeVM.onHideLoading();
                messageBarVM.showError("Edit Waiver Failed.");
            }
        });
    }, [counterCustomerChargeVM, counterCustomerChargeState.selectedRows, counterCustomerChargeState.searchCriteria, messageBarVM]);
    const handleSupplementaryWaiver = useCallback(async () => {
        counterCustomerChargeVM.onMore("SuppleWaiver", [])
    }, [counterCustomerChargeVM]);

    const handleDelete = useCallback(async () => {
        let ids: number[] = [];
        let msg = '';
        if (_.isEmpty(selectedRows)) {
            setIsDeleteMsg(false);
            messageBarVM.showError('Please select record(s).');
            return;
        }
        selectedRows.forEach(row => {
            if (row.adjType === 'Normal' && row.cntrStatus1 !== 'R' && row.cntrStatus1 !== 'E' && row.isExtensionInd !== 'Y') {
                msg = "Record(s) cannot be deleted, Adjustment type is 'Normal'.";
                return;
            }
            if (row.adjType === 'Normal' && row.isExtensionInd === 'Y' && row.slabsChargeInd === 'Y') {
                msg = "Record(s) cannot be deleted, Adjustment type is 'Normal'.";
                return;
            }
            if (row.adjType === 'Normal' && row.isExtensionInd === 'Y' && row.slabsChargeInd === 'N' && (row.dtlState === 'I' || row.dtlState === 'DI')) {
                msg = "Record(s) cannot be deleted,detail state is 'I' or 'DI'.";
                return;
            }
            if (row.adjType !== 'Normal' && (row.dtlState === 'I' || row.dtlState === 'DI')) {
                msg = "Record(s) cannot be deleted,detail state is 'I'.";
                return;
            }
            if (row.adjType === 'Recal') {
                msg = "The Adjustment Type is RECAL, cannot delete.";
                return;
            }
            if (row.id) {
                ids.push(row.id);
            }
        })
        if (msg !== '') {
            setIsDeleteMsg(false);
            messageBarVM.showError(msg);
            return;
        }
        counterCustomerChargeVM.onShowLoading();
        counterCustomerChargeVM.onDelete(ids).then(async (data) => {
            counterCustomerChargeVM.onHideLoading();
            setIsDeleteMsg(false);
            await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
            if (data && data.toString().startsWith("Error:")) {
                messageBarVM.showError(data.toString().replace("Error:", ""));
            } else {
                messageBarVM.showSuccess("Delete Successfully.");
            }
        });
    }, [counterCustomerChargeVM, selectedRows, counterCustomerChargeState.searchCriteria, messageBarVM]);

    const handleAdjustment = useCallback(async () => {
        if (_.isEmpty(selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }
        if (selectedRows.some(row => row.dtlState !== "I")) {
            messageBarVM.showError('The invoice/credit note has not been generated for the container.');
            return;
        }
        counterCustomerChargeVM.onCheckAdjustment(selectedRows).then(async (res) => {
            if (res && res.success) {
                if (res.data) {
                    messageBarVM.showError(res.data);
                } else {
                    counterCustomerChargeVM.onMore("Adjustment", selectedRows)
                }
            } else {
                messageBarVM.showError("Adjustment Failed.");
            }
        });
    }, [counterCustomerChargeVM, selectedRows, messageBarVM]);

    const handleChargeQty = useCallback(async () => {
        if (_.isEmpty(selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }
        counterCustomerChargeVM.onMore("ChargeQty", selectedRows)
    }, [counterCustomerChargeVM, selectedRows, messageBarVM]);

    const handleExtraLabor = useCallback(async () => {
        if (_.isEmpty(selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }
        counterCustomerChargeVM.onMore("ExtraLabor", selectedRows)
    }, [counterCustomerChargeVM, selectedRows, messageBarVM]);

    const handleAccTerminal = useCallback(async () => {
        if (_.isEmpty(selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }
        let isExistT = false;
        let entityList: CounterCustomerChargeEntity[] = [];
        selectedRows.forEach(row => {
            let editingEntity = { ...row };
            if (editingEntity.dtlState === "T" || editingEntity.dtlState === "MT") {
                isExistT = true;
            } else {
                if (counterCustomerChargeState.dynamicOptions.acctTmlReasonCodeDropdownOptions.length > 0) {
                    editingEntity.accountTmlReasonCode = counterCustomerChargeState.dynamicOptions.acctTmlReasonCodeDropdownOptions[0].value;
                }
            }
            entityList.push(editingEntity);
        });

        if (isExistT) {
            counterCustomerChargeVM.onShowLoading();
            counterCustomerChargeVM.onAccTerminal(entityList).then((res) => {
                if (res && res.success) {
                    messageBarVM.showSuccess('Account Terminal / Resume Successfully.');
                    counterCustomerChargeVM.onMoreClose();
                    counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                } else {
                    messageBarVM.showError('Account Terminal / Resume Failed.');
                }
                counterCustomerChargeVM.onHideLoading();
            });
        } else {
            counterCustomerChargeVM.onMore("AccTerminal", selectedRows)
        }
    }, [counterCustomerChargeVM, selectedRows, messageBarVM, counterCustomerChargeState.searchCriteria, counterCustomerChargeState.dynamicOptions.acctTmlReasonCodeDropdownOptions]);

    const handleHold = useCallback(async () => {
        if (_.isEmpty(selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }
        counterCustomerChargeVM.onShowLoading();
        const ids = selectedRows.map(x => x.id);
        counterCustomerChargeVM.onHoldUnHold(ids).then(async (data) => {
            if (data && data.success) {
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                counterCustomerChargeVM.onHideLoading();
                messageBarVM.showSuccess("Hold / Un-Hold Successfully.");
            } else {
                await counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                counterCustomerChargeVM.onHideLoading();
                messageBarVM.showError("Hold / Un-Hold Failed.");
            }
        });
    }, [counterCustomerChargeVM, selectedRows, messageBarVM, counterCustomerChargeState.searchCriteria]);

    const handleStuffing = useCallback(async () => {
        if (_.isEmpty(selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }
        if (selectedRows.some(row => row.cntrStatus1 === "EM")) {
            messageBarVM.showError("EM Container, Can't do CFS Stuffing and Unstuffing");
            return;
        }
        counterCustomerChargeVM.onMore("Stuffing", selectedRows)
    }, [counterCustomerChargeVM, selectedRows, messageBarVM]);

    const handleReHandling = useCallback(async () => {
        const searchCriteria = counterCustomerChargeState.searchCriteria;
        let cntrList: string[] = [];
        let blList: string[] = [];
        if (_.isEmpty(tableData)) {
            if (!searchCriteria.billOfLadingNo && (!searchCriteria.cntrList || searchCriteria.cntrList.length === 0 || (searchCriteria.cntrList.length === 1 && searchCriteria.cntrList[0] === ''))) {
                messageBarVM.showError('Please enter bill of lading# or container#.');
                return;
            }
            if (searchCriteria.cntrList && searchCriteria.cntrList[0] !== '') {
                cntrList = searchCriteria.cntrList;
            }
            if (searchCriteria.billOfLadingNo) {
                blList.push(searchCriteria.billOfLadingNo);
            }
        } else {
            if (selectedRows.length === 1) {
                let msg = null;
                tableData.forEach(row => {
                    if (row.cntrNo === selectedRows[0].cntrNo && (row.dtlState === "R" || row.dtlState === "F" || row.dtlState === "C" || row.dtlState === "E" ||
                        row.dtlState === "Z" || row.dtlState === "X" || row.dtlState === "SG" || row.dtlState === "DI")) {
                        msg = row.cntrNo + ' Existing Record status is ' + row.dtlState + ', cannot Import Re-Handling';
                        return;
                    }
                });
                if (msg != null) {
                    messageBarVM.showError(msg);
                    return;
                }
                blList.push(selectedRows[0].billOfLading ?? '');
                cntrList.push(selectedRows[0].cntrNo ?? '');
            } else {
                messageBarVM.showError('Please select a record.');
                return;
            }
        }
        let criteria: ImportReHandlingCriteria = {
            cntrList: cntrList,
            billOfLadingNo: blList
        };
        counterCustomerChargeVM.onShowLoading();
        counterCustomerChargeVM.onImportReHandling(criteria).then((res) => {
            if (res && res.success) {
                if (res.data) {
                    messageBarVM.showError(res.data);
                } else {
                    messageBarVM.showSuccess('Import Re-Handling Successfully.');
                }
            } else {
                messageBarVM.showError('Import Re-Handling Failed.');
            }
            counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
            counterCustomerChargeVM.onHideLoading();
        });
    }, [counterCustomerChargeVM, selectedRows, messageBarVM, counterCustomerChargeState.searchCriteria, tableData]);

    const memoCommonAccountMenu = useMemo(() => {
        let markMt = {};
        if (allowUpdateMarkMT) {
            markMt = {
                title: CounterCustomerChargeMaintenanceConstant.BUTTON.MARK_MT,
                disabled: !isEnableMarkMT,
                command: () => { handleMarkMt() }
            };
        }

        const updateInvoiceInfo = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.UPDATE_INVOICE_INFO,
            disabled: !isEnableExciseCashNo,
            command: () => { handleUpdateInvoiceInfo() }
        };
        const updatePaidThroughDate = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.UPDATE_PAID_THROUGH_DATE,
            disabled: !isEnablePaidThroughDate,
            command: () => { handleUpdatePaidThroughDate() }
        };
        const updateAgentDeliveryDate = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.UPDATE_AGENT_DELIVERY_DATE,
            disabled: !isEnableAgentDeliveryDate,
            command: () => { handleUpdateAgentDeliveryDate() }
        };
        const preview = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.PREVIEW,
            disabled: !isEnablePreview,
            command: () => { handlePreview() }
        }
        const chargeOnCompany = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.UPDATE_CHARGE_ON_COMPANY,
            disabled: !isEnabledChargeCom,
            command: () => { handleUpdateChargeOnCompany() }
        }
        const billToCompany = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.UPDATE_BILL_TO_COMPANY,
            disabled: !isEnabledBillCom,
            command: () => { handleUpdateBillToCompany() }
        }
        const waiverReasonCode = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.WAIVER_REASON_CODE,
            disabled: !isEnabledWaiver,
            command: () => { handleWaiverReasonCode() }
        }
        const editWaiver = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.EDIT_WAIVER,
            disabled: !isEnabledEditWaiver,
            command: () => { handleEditWaiver() }
        }
        const supplementaryWaiver = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.SUPPLEMENTARY_WAIVER,
            disabled: !isEnabledSuppleWaiver,
            command: () => { handleSupplementaryWaiver() }
        }
        let deleteButton = {}
        if (allowUpdateDelete) {
            deleteButton = {
                title: CounterCustomerChargeMaintenanceConstant.BUTTON.DELETE,
                disabled: !isEnableDelete,
                command: () => { handleShowDelete() }
            }
        }
        let adjustment = {}
        if (allowUpdateAdjustment) {
            adjustment = {
                title: CounterCustomerChargeMaintenanceConstant.BUTTON.ADJUSTMENT,
                disabled: !isEnableAdjustment,
                command: () => { handleAdjustment() }
            }
        }
        const chargeQty = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.CHARGE_QTY,
            disabled: !isEnableChargeQty,
            command: () => { handleChargeQty() }
        }
        const extraLabor = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.EXTRA_LABOR,
            disabled: !isEnableExtraLabor,
            command: () => { handleExtraLabor() }
        }
        const accountTerminal = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.ACCOUNT_TERMINAL,
            disabled: !isEnableAccTerminal,
            command: () => { handleAccTerminal() }
        }
        const hold = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.HOLD,
            disabled: !isEnableHoldUnhold,
            command: () => { handleHold() }
        }
        const stuffing = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.STUFFING,
            disabled: !isEnableCfsStuffing,
            command: () => { handleStuffing() }
        }
        const reHandling = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.RE_HANDLING,
            disabled: !isEnableImporiReHandling,
            command: () => { handleReHandling() }
        }
        const extensionPayment = {
            title: CounterCustomerChargeMaintenanceConstant.BUTTON.EXTENSION_PAYMENT,
            disabled: !isEnableExtensionPayment,
            command: () => { handleExtensionPayment() }
        }

        if (operatingUnit === 'SAPT' || operatingUnit === 'KICT') {
            return [markMt, updateInvoiceInfo, updatePaidThroughDate, preview, chargeOnCompany, billToCompany, waiverReasonCode, editWaiver, supplementaryWaiver];
        } else if (operatingUnit === 'OICT') {
            return [markMt, deleteButton, adjustment, updatePaidThroughDate, updateAgentDeliveryDate, extensionPayment, preview, chargeQty, extraLabor, chargeOnCompany, billToCompany, waiverReasonCode];
        } else if (operatingUnit === 'HPJZ') {
            return [markMt, deleteButton, adjustment, updatePaidThroughDate, preview, accountTerminal, hold, chargeQty, chargeOnCompany, billToCompany, waiverReasonCode];
        } else if (operatingUnit === 'AQCT' || operatingUnit === 'RSCT') {
            return [markMt, deleteButton, adjustment, stuffing, reHandling, updatePaidThroughDate, preview, accountTerminal, hold, chargeQty, chargeOnCompany, billToCompany, waiverReasonCode];
        }
        return []
    }, [allowUpdateMarkMT, isEnableExciseCashNo, isEnablePaidThroughDate, isEnableAgentDeliveryDate, isEnablePreview, isEnabledChargeCom, isEnabledBillCom, isEnabledWaiver, isEnabledEditWaiver, isEnabledSuppleWaiver, allowUpdateDelete, allowUpdateAdjustment, isEnableChargeQty, isEnableExtraLabor, isEnableAccTerminal, isEnableHoldUnhold, isEnableCfsStuffing, isEnableImporiReHandling, isEnableExtensionPayment, operatingUnit, isEnableMarkMT, handleMarkMt, handleUpdateInvoiceInfo, handleUpdatePaidThroughDate, handleUpdateAgentDeliveryDate, handlePreview, handleUpdateChargeOnCompany, handleUpdateBillToCompany, handleWaiverReasonCode, handleEditWaiver, handleSupplementaryWaiver, isEnableDelete, handleShowDelete, isEnableAdjustment, handleAdjustment, handleChargeQty, handleExtraLabor, handleAccTerminal, handleHold, handleStuffing, handleReHandling, handleExtensionPayment]);

    const memoMoreIconButton = useMemo(() => {
        let disabled: boolean = false;
        /*if (isShowBatchUpdatePanel || isShowUpdateVesselVoyageMasterSearchPanel || isShowUpdateVesselVoyageMasterTablePanel ||
            isShowAssignSeqNoPanel || isShowUpdateStatus || !memoCommonAccountMenu?.find(menu => menu.disabled !== true)
        ) {
            disabled = true;
        }*/
        return <OverflowMenuButton buttonLabel={WorkspaceConstant.Common.BUTTON_MORE} disabled={disabled}
            toolTipText={WorkspaceConstant.Common.BUTTON_MORE} navigationList={memoCommonAccountMenu} buttonSize={"Small"} buttonTheme={"Secondary"} />
    }, [memoCommonAccountMenu])

    const isDisabled = useMemo(() => {
        return tableData?.length === 0;
    }, [tableData?.length]);

    const isCollectionDisabled = useMemo(() => {
        if (counterCustomerChargeState.selectedRows?.filter(row => row.dtlState === 'DI').length === 0) {
            return true;
        };
        return tableData?.length === 0;
    }, [tableData?.length, counterCustomerChargeState.selectedRows]);

    return <Sidebarheader style={{ width: '100%' }}>
        <HeaderWithBackButton callback={counterCustomerChargeVM.onClose}>
            <Breadcrumb>
                <HPHBreadcrumb breadcrumbData={[{ title: CounterCustomerChargeMaintenanceConstant.CATEGORY }, { title: CounterCustomerChargeMaintenanceConstant.TITLE }]} onCurrentClick={() => { }}></HPHBreadcrumb>
            </Breadcrumb>
        </HeaderWithBackButton>
        <StyledAction className={"tm-animated-wrapper"}>
            <IconButton fileName='Icon-search' size='medium' toolTipText={'Search'} toolTipArrow={false} onClick={counterCustomerChargeVM.onSerachPanl} />
            {allowCreate && <IconButton fileName='Icon-add' disabled={false} size='medium' toolTipText={'Add'} toolTipArrow={false} onClick={handleAdd} />}
            {allowUpdate && <><div className="add-seperator" />
                <HPHButton label={WorkspaceConstant.Common.BUTTON_UPDATEALL} disabled={isDisabled} size={'Small'} theme={'Secondary'} onClick={handleApplyAll} />
                {<HPHButton label={WorkspaceConstant.Common.BUTTON_CONFIRM_SUBMIT} disabled={isDisabled} size={'Small'} theme={(operatingUnit === 'SAPT' || operatingUnit === 'KICT') ? 'Primary' : 'Secondary'} onClick={handleConfirm} />}
                {operatingUnit !== 'SAPT' && operatingUnit !== 'KICT' && <HPHButton label={WorkspaceConstant.Common.BUTTON_COLLECTION} disabled={isCollectionDisabled} size={'Small'} theme={'Primary'} onClick={handleCollectionAndCheck} />}
                <div className="add-seperator" />
                {/*<IconButton fileName='Icon-pen' size='medium' toolTipText={'Edit'} toolTipArrow={false} onClick={handleEdit} />*/}
                {memoMoreIconButton}</>}
            {(isShowCollectionMsg) && (operatingUnit === 'AQCT' || operatingUnit === 'RSCT') && <CommonMessageModal headerText={""}
                contentText={"Cannot connect to nGen. Do you confirm to continue to process collection ?"}
                visible={isShowCollectionMsg}
                footerButtons={[
                    { label: 'Yes', theme: 'Primary', onClick: handleCollection },
                    { label: 'No', theme: 'Secondary', onClick: handleCancel },
                ]}
            />}
            {isShowDeleteMsg && <ConfirmDeleteModal headerText={`${WorkspaceConstant.Common.BUTTON_DELETE} ${CounterCustomerChargeMaintenanceConstant.TITLE}`}
                contentText={`${MessageConstant.common.DELETE_ALERT_TITLE}\n${MessageConstant.common.DELETE_ALERT_MESSAGE}`}
                visible={isShowDeleteMsg}
                onCancelClick={handleCancelDelete}
                onDeleteClick={handleDelete}
            />}
        </StyledAction>
    </Sidebarheader>
}

export default memo(CounterCustomerChargeDetailPanelTitleBar);